/* eslint-disable @typescript-eslint/no-explicit-any */
import { convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import React, { useContext, useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { listAttachments } from '../../../../assets/ts/data/files/files'
import { LIST_NAME } from '../../../../assets/ts/data/q-and-a'
import { convertRTE } from '../../../../assets/ts/formatting/formatting'
import {
  addToPIIAuditTrail,
  getPIIScanInfo,
  handlePIIValidationFailure,
  loadPII,
} from '../../../../assets/ts/pii/pii'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import FileUpload from '../../../../components/file-upload/file-upload'
import PIIPopup from '../../../../components/page-overlay/pii-popup'
import { MetadataContextInterface } from '../../../../store/metadata-context-provider'
import { UserContext } from '../../../../store/user-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
} from '../../../../utils/constants/global-constants'
import { NO_CHANGE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import InputText from '../../../../utils/controls/input-text'
import RichTextEditor from '../../../../utils/controls/rich-text-edit'
import { IsArchived, Status, optionsTypes } from '../../../../utils/controls/select-options-data'

interface addOrEditProps {
  assignedComponentOptions: any
  cancel?: () => void
  categories?: MetadataContextInterface['categories']
  clickedIndex? : number
  components?: MetadataContextInterface['components']
  fetchQAndA: () => void
  filtersvalue?: any
  initialMajcomOptions?: any
  initialSectionOptions?: any  
  initialSquadronOptions?: any
  majcoms?: MetadataContextInterface['majcoms']
  qAndA?: any
  roleContext?: any
  sections?: MetadataContextInterface['sections']
  showAddPopup?: any
  showEdit?: any
  visibleSquadrons?: any
}

const AddEditView = ({
  assignedComponentOptions,
  cancel,
  categories,
  clickedIndex,
  fetchQAndA,
  filtersvalue,
  initialMajcomOptions,
  initialSectionOptions,
  qAndA,
  roleContext,
  sections,
  showAddPopup,
  showEdit,
  visibleSquadrons
}: addOrEditProps) => {
  const { me } = useContext(UserContext)
  const [replaceFile, setReplaceFile] = useState(false)
  const [showAlert, setShowAlert] = useState(false)

  const titleRef: any = useRef<any>(null)
  const descriptionRef = useRef<any>(null)

  const existingFiles = qAndA?.Attachments[0]?.blobs ? qAndA?.Attachments[0]?.blobs : []


  const [categoryOptions, setCategoryOptions] = useState<optionsTypes[]>([])
  const [majcomOptions, setMajcomOptions] = useState<optionsTypes[]>([])
  const [sectionOptions, setSectionOptions] = useState<Array<optionsTypes>>([ALL_SELECT_OPTION])
  const [squadronOptions, setSquadronOptions] = useState<Array<optionsTypes>>(
    [ALL_SELECT_OPTION_STRING]
  )
  const [displayValidation, setDisplayValidation] = useState({
    showPII: false,
  })
  const [files, setFiles] = useState(existingFiles)
  const [inputValues, setInputValues] = useState({
    Answer: qAndA?.Answer ? qAndA.Answer : '',
    AssignedComponent: qAndA?.AssignedComponent ? qAndA.AssignedComponent : ALL_SELECT_LABEL,
    AssignedComponentCode: qAndA?.AssignedComponentCode
      ? qAndA.AssignedComponentCode
      : ALL_SELECT_VALUE,
    CategoryCodeOptions: [],
    CategoryCodes: qAndA?.CategoryCodes?.length > 0 ?
      qAndA.CategoryCodes : [],
    Description: qAndA?.Description ? qAndA.Description : '',
    IsArchived: qAndA?.IsArchived ? qAndA.IsArchived : false,
    Question: qAndA?.Question ? qAndA.Question : '',
    SectionCodeOptions: [],
    SectionCodes: qAndA?.SectionCodes?.length > 0 ?
      qAndA.SectionCodes : [],
    ServicingMAJCOM: qAndA?.ServicingMAJCOM ? qAndA.ServicingMAJCOM : ALL_SELECT_LABEL,
    ServicingMAJCOMCode: qAndA?.ServicingMAJCOMCode ? qAndA.ServicingMAJCOMCode : ALL_SELECT_VALUE,
    Squadron: qAndA?.Squadron ? qAndA.Squadron : '',
    Status: qAndA?.Status ? qAndA.Status : '',
    Tags: qAndA?.Tags ? qAndA.Tags : '',
  })
  const [piiScan, setPIIScan] = useState({})
  const [qAndAValidations, setQAndAValidations] = useState({
    Answer: false,
    AssignedComponent: false,
    Description: false,
    MAJCOM: false,
    Question: false,
    Section: false,
    Status: false,
  })

  const [fileError, setFileError] = useState(false)

  useEffect(() =>{
    const titleElemnt = document.getElementById('Question')
    if(titleRef?.current && titleElemnt){
      if(clickedIndex === 0){
        descriptionRef?.current?.scrollIntoView({behavour: 'auto', block: 'end'})
        titleElemnt.focus()
      }else if(clickedIndex === 1){
        descriptionRef?.current?.scrollIntoView({behavour: 'auto', block: 'nearest'})
        titleElemnt.focus()
      }else{
        titleRef?.current?.scrollIntoView(false)
        titleElemnt.focus()
      }
    }
  }, [titleRef, showEdit, descriptionRef])

  useEffect(() => {
    const majOptions: any[] = initialMajcomOptions
      .filter(
        (item) => item.assignedComponentCode === inputValues.AssignedComponentCode ||
        inputValues.AssignedComponentCode === -1
      )
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((e) => e.section === formattedSection &&
                majOptions.some((maj) => e.squadron.includes(maj.squadron)))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions = []
    majOptions.filter((majcom) => majcom.squadron).map((majcom) => {
      majcom.squadron?.map((item) => {
        squadOptions.push({
          label: item,
          value: item
        })
      })
    })

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    handleChange('AssignedComponent', assignedComponentOptions.length === 1 ? assignedComponentOptions[0].label ?? '' : ALL_SELECT_LABEL)
    handleChange('AssignedComponentCode', assignedComponentOptions.length === 1 ? assignedComponentOptions[0].value ?? '' : ALL_SELECT_VALUE)
    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('ServicingMAJCOM', majOptions.length === 1 ? majOptions[0].label ?? '' : ALL_SELECT_LABEL)
    handleChange('ServicingMAJCOMCode', majOptions.length === 1 ? majOptions[0].value ?? '' : ALL_SELECT_VALUE)
    showAddPopup && handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? ''  ?? '' : ALL_SELECT_VALUE_STRING)
    !showAddPopup && handleChange('Squadron', qAndA?.Squadron === '' ? ALL_SELECT_VALUE_STRING : qAndA?.Squadron)
  }, [
    assignedComponentOptions,
    initialMajcomOptions,
    initialSectionOptions,
    qAndA
  ])

  useEffect(() => {
    if (qAndA) {
      setInputValues((prev) => ({
      ...prev,
      AssignedComponent: qAndA?.AssignedComponent,
      AssignedComponentCode: qAndA?.AssignedComponentCode,
      CategoryCodeOptions: qAndA?.CategoryCodes?.map((categoryCode, index) => ({
        label: qAndA?.Category[index],
        value: categoryCode
      })),
      CategoryCodes: qAndA?.CategoryCodes?.length > 0 ?
        qAndA.CategoryCodes : [],
      SectionCodeOptions: qAndA?.SectionCodes?.map((sectionCode, index) => ({
        label: qAndA?.Section[index],
        value: sectionCode
      })),
      SectionCodes: qAndA?.SectionCodes?.length > 0 ?
        qAndA.SectionCodes : [],
    }))}

  }, [qAndA])

  const isFilesChanged = () => {
    const filesSet = new Set(files.map((file) => (file.fileName ? file.fileName : file.name)))
    const existingFilesSet = new Set(existingFiles.map((file) => file.fileName))
    const hasDifferences =
      existingFiles.some((aItem) => !filesSet.has(aItem.fileName)) ||
      files.some((aItem) => !existingFilesSet.has(aItem.fileName))
    return hasDifferences
  }

  const generateMajcomOptions = (
    eValue: string | undefined,
    assignComponents: MetadataContextInterface['components'],
    majcoms: MetadataContextInterface['majcoms']
  ): optionsTypes[] => {
    const defaultOption = ALL_SELECT_OPTION
    if (!eValue) return [defaultOption]
    const componentCode =
      eValue === 'All' ? -1 : assignComponents.find((item) => item.Label === eValue)?.ComponentCode
    if (!componentCode) return [defaultOption]
    const filteredMajcoms = majcoms.filter(
      (item) => componentCode === -1 || item.ParentComponentCode === componentCode
    )
    const mappedOptions = filteredMajcoms.map(({ Label, Value }) => ({
      label: Label,
      value: Value,
    }))
    if (mappedOptions.length > 1) {
      mappedOptions.unshift(defaultOption)
    }
    return mappedOptions
  }

  const generateCategoryOptions = (
    sectionLabel: string | undefined,
    categories: MetadataContextInterface['categories'],
    sections: MetadataContextInterface['sections']
  ): optionsTypes[] => {

    if (!sectionLabel) return []

    const section = sections.find((metadata) => metadata.Label === sectionLabel)

    if (!section && sectionLabel !== 'All') return []

    const filteredCategories = categories.filter(
      (item) => sectionLabel === 'All' || item.ParentSectionCode === section?.SectionCode
    )
    return [
      ...filteredCategories.map(({ Label, Value }) => ({
        label: Label,
        value: Value,
      })),
    ]
  }

  const handleChange = (key: string, value: boolean | number | string) => {
    setInputValues((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const changeAssignedComponent = (e: { label: string; value: number }) => {
    const majOptions: any[] = initialMajcomOptions
      .filter(
        (item) => item.assignedComponentCode === e.value || e.value === -1
      )
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((e) => e.section === formattedSection &&
                majOptions.some((maj) => e.squadron.includes(maj.squadron)))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions = []
    majOptions.filter((majcom) => majcom.squadron).map((majcom) => {
      majcom.squadron?.map((item) => {
        squadOptions.push({
          label: item,
          value: item
        })
      })
    })

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    handleChange('AssignedComponent', e.label)
    handleChange('AssignedComponentCode', e.value)
    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('ServicingMAJCOM', majOptions.length === 1 ? majOptions[0].label ?? '' : ALL_SELECT_LABEL)
    handleChange('ServicingMAJCOMCode', majOptions.length === 1 ? majOptions[0].value ?? '' : ALL_SELECT_VALUE)
    handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)
  }

  const changeMajcom = (e: { label: string; value: number }) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (e.squadron.includes(sect.squadron) || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    let squadOptions = []

    if (e?.squadron) {
      e.squadron?.map((item) => {
          squadOptions.push({
            label: item,
            value: item
          })
      })
    } else {
      squadOptions = []
      majcomOptions.filter((majcom) => majcom.squadron).map((majcom) => {
        majcom.squadron?.map((item) => {
          squadOptions.push({
            label: item,
            value: item
          })
        })
      })
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)
    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('ServicingMAJCOM', e.label)
    handleChange('ServicingMAJCOMCode', e.value)
    handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)
  }

  const changeSquadron = (e: any) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (sect.squadron === e.value || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    setSectionOptions(sectOptions)

    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('Squadron', e.value)
  }

  const changeSection = (e: { label: string; value: number }) => {
    const options = []

    e.forEach((section) => {
      options.push(generateCategoryOptions(
        section.label,
        categories ?? [],
        sections ?? []
      ))
    })

    setCategoryOptions([...new Set(...options)])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('SectionCodes', sectionOptions.length === 1 ? [sectionOptions[0].value] : [...e.map((section) => section.value)])
    handleChange('SectionCodeOptions', sectionOptions.length === 1 ? [sectionOptions[0]] : e)
  }

  const changeCategory = (e: { label: string; value: number }) => {
    handleChange('CategoryCodes', categoryOptions.length === 1 ? [categoryOptions[0].value] : [...e.map((category) => category.value)])
    handleChange('CategoryCodeOptions', categoryOptions.length === 1 ? [categoryOptions[0]] : e)
  }

  const validateQAndA = () => {
    let isValid = true

    const validations = {
      Answer: false,
      AssignedComponent: false,
      Description: false,
      MAJCOM: false,
      Question: false,
      Section: false,
      Status: false,
    }

    if (
      !inputValues?.Answer.getCurrentContent().hasText() ||
      !inputValues?.Answer.getCurrentContent().getPlainText().trim()
    ) {
      isValid = false
      validations.Answer = true
    }
    if (
      !inputValues?.Description.getCurrentContent().hasText() ||
      !inputValues?.Description.getCurrentContent().getPlainText().trim()
    ) {
      isValid = false
      validations.Description = true
    }
    if (inputValues.Question === '') {
      isValid = false
      validations.Question = true
    }
    if (inputValues.Status === '') {
      isValid = false
      validations.Status = true
    }

    setQAndAValidations(validations)
    return isValid
  }

  const generateCode = (code: number) => {
    return code > 0 ? code : null
  }
  const handleInputChangeRichText = (e) => {
    handleChange('Description', e)
  }
  const handleRichTextAnswer = (e) => {
    handleChange('Answer', e)
  }

  /**validateAndHandlePIISubmission
   * Validates the PII (Personally Identifiable Information) for submission and handles the submission process.
   *
   * @param {string} action - The action being performed (e.g., 'submitted').
   * @param {string} position - The position to displayValidation PII compliance validation messages ('top' or 'bottom').
   * @returns {boolean} - Indicates whether the submission can proceed.
   */
  const validateAndHandlePIISubmission = async (action = 'submitted') => {
    let canSubmit = true
    const piiScanData = {
      Answer: convertRTE(inputValues?.Answer),
      Description: convertRTE(inputValues?.Description),
      FileArray: Object.values(files),
      Question: inputValues.Question,
    }
    try {
      const uploadData = await getPIIScanInfo(piiScanData, piiScan)
      if (action === 'submitted') {
        setPIIScan({ ...uploadData.piiScanResult })
      }
      if (uploadData.canSubmit) {
        canSubmit = true
      } else {
        handlePIIValidationFailure(null, setDisplayValidation)
        canSubmit = false
      }
    } catch (error) {
      console.error('PII validation failed:', error)
      canSubmit = false
    }
    return canSubmit
  }

  const generateString = (options: any) => {
    return JSON.stringify(options.map((options) => options.label))
  }

  const handleSubmit = async () => {
    let isValid = validateQAndA()
    const currentDate = new Date()
    let tagsValid = true
    let filesValid = true

    if (qAndA && qAndA.tags?.length > 0) {
      const tags = inputValues.Tags.split(',')

      qAndA?.tags.forEach((tag) => {
        if (!tags.includes(tag)) {
          tagsValid = false
        }
      })
      if (tagsValid) {
        tagsValid = qAndA.tags.length !== tags.length
      }
    } 

    if (files.length > 0) {
      files.forEach((file) => {
        if (qAndA?.Attachments?.filter((attachment) => 
          attachment.blobs[0].fileName === file.name).length > 0) {
            filesValid = false
        }
      })
    } else if (qAndA?.Attachments?.length > 0) {
      filesValid = false
    }
    if (    
      (qAndA?.AssignedComponentCode === inputValues.AssignedComponentCode) &&
        qAndA?.IsArchived  === inputValues.IsArchived &&
      (qAndA?.ServicingMAJCOMCode === inputValues.ServicingMAJCOMCode) &&    
        qAndA?.Answer === draftToHtml(
          convertToRaw(inputValues?.Answer.getCurrentContent())
        ) &&
        qAndA?.Question === inputValues.Question &&   
        qAndA?.Description === draftToHtml(
          convertToRaw(inputValues?.Description.getCurrentContent())
        ) &&
        qAndA?.Status === inputValues.Status &&       
        !tagsValid &&   
        filesValid &&        
        qAndA?.SectionCodes.sort().join(',') === inputValues?.SectionCodes.sort().join(',') &&
        qAndA?.CategoryCodes.sort().join(',') === inputValues?.CategoryCodes.sort().join(',')) {
        isValid = false
        setShowAlert(true)
      }

    if (isValid) {
      const piiIsValid = await validateAndHandlePIISubmission('submitted')
      if (piiIsValid) {
      try {
          const addObj = {
            Answer: draftToHtml(convertToRaw(inputValues?.Answer.getCurrentContent())),
            AssignedComponentCode: generateCode(inputValues.AssignedComponentCode),
            Category: generateString(inputValues.CategoryCodeOptions),
            CategoryCodes: JSON.stringify(inputValues.CategoryCodes),            
            Description: draftToHtml(convertToRaw(inputValues?.Description.getCurrentContent())),
            IsArchived: inputValues.IsArchived,
            ItemCreated: currentDate,
            ItemCreatedBy: me.rid,
            ItemModified: currentDate,
            ItemModifiedBy: me.rid,
            Question: inputValues?.Question,
            Section: generateString(inputValues.SectionCodeOptions),
            SectionCodes: JSON.stringify(inputValues.SectionCodes),
            ServicingMAJCOMCode: generateCode(inputValues.ServicingMAJCOMCode),
            Squadron: inputValues.Squadron,
            Status: inputValues?.Status,
            Tags: inputValues?.Tags,
            eKey: qAndA ? qAndA.eKey : '',
            eTag: qAndA ? qAndA.eTag : '',
          }

          const list = await mpfRListsHttp().getList(LIST_NAME)
          const qAndAEntry = await list.addOrUpdateItem(addObj)
          addToPIIAuditTrail('Settings-Q&A', addObj.eKey, piiScan, me.rid)
          setDisplayValidation((prev) => ({
            ...prev,
            showPII: false,
          }))
          if (qAndA && isFilesChanged()) {
            const deletedFiles = existingFiles.filter(
              (aItem) => !files.some((bItem: any) => bItem.fileName === aItem.fileName)
            )
            try {
              for (const element of deletedFiles) {
                const deletedEtag = element.eTag
                await list
                  .blobs()
                  .delete(qAndA.eKey, element.fileName, element.folderName, deletedEtag)
              }
            } catch (error) {
              console.error('Error occurred while deleting attachment:', error)
            }
          }
          if (files?.length > 0) {
            await listAttachments(LIST_NAME, qAndAEntry.eKey, files)
          }
  
          fetchQAndA()
        } catch (err) {
          console.error(err)
        } finally {
          showAddPopup ? filtersvalue(!showAddPopup) : cancel?.()
        }
      }
    }
  }

  const onClickAlert = () => {
    setShowAlert(false)
  }
  useEffect(() => {

    const categoryOpt = [
      ...(categories ?? []).map((c) => ({
        label: c.Category,
        value: c.CategoryCode,
      })),
    ]

    setCategoryOptions(categoryOpt)
  }, [])
  useEffect(() => {
    setDisplayValidation((prev) => ({
      ...prev,
      showPII: false,
    }))
    if (Object.keys(piiScan).length > 0) {
      Object.keys(piiScan).forEach((key) => {
        if (key === 'FileArray') {
          for (const file of piiScan[key].value) {
            if (file?.resultsArray?.length > 0 && !file?.userAnswer) {
              setDisplayValidation((prev) => ({
                ...prev,
                showPII: true,
              }))
            }
          }
        } else {
          if (piiScan[key]?.resultsArray?.length > 0 && !piiScan[key]?.userAnswer) {
            setDisplayValidation((prev) => ({
              ...prev,
              showPII: true,
            }))
          }
        }
      })
    }
  }, [piiScan])

  useEffect(() => {
    loadPII()
  }, [])
  return (
    <div
      className={
        showAddPopup
          ? 'mx-2 border-radius whitebg border-primary mt-2'
          : 'settingseditpopup w-100 position-relative border-top1 mt-2'
      }
      id='scroll'
    >
      {showAlert && (
        <Alert
        alerttextclass='poppins-semibold font-13 text-center'
        btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
        btn1iconclassNmae='icon-checked font-12 pe-1'
        btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
        btn2iconclassNmae='icon-close color-primary font-12 pe-1'
        cancel='Cancel'
        className='alert-info'
        message={NO_CHANGE_MESSAGE}
        onClick={onClickAlert}
        yes='OK'
      />
      )}
      {showAddPopup && (
        <div className='p-3 border-bottom1'>
          <h4
            aria-label='Add Q & A'
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            Add Q & A
          </h4>
        </div>
      )}
      {displayValidation.showPII && <PIIPopup piiScan={piiScan} setPIIScan={setPIIScan} />}

      <div className='px-2 py-1'>
        <div className='row'>
          <div className='col-sm-12 col-lg-12 mb-2' ref={titleRef}>
            <InputText
              changeHandler={(e) => handleChange('Question', e.target.value)}
              className='form-lg font-13 sourcesanspro'
              errorMessage={qAndAValidations.Question}
              formClassName=' form-vertical'
              info='Question'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'Question',
                name: 'Question',
                placeholder: 'Enter Question',
                value: inputValues.Question,
              }}
              isInfo
              isMandatory
              label='Question'
              msg='Please enter Question'
              value={inputValues.Question}
            />
          </div>
          <div className='col-sm-12 col-lg-12 mb-2'>
            <RichTextEditor
              editorValue={inputValues.Description}
              error={qAndAValidations.Description}
              formClassName='d-flesx flex-column'
              info='Description'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' Description ',
                name: ' Description',
                placeholder: 'Enter Description',
              }}
              isInfo
              isMandatory
              label='Description'
              sendValue={handleInputChangeRichText}
            />
          </div>
          <div className='col-sm-12 col-lg-12 mb-2'>
            <RichTextEditor
              editorValue={inputValues.Answer}
              error={qAndAValidations.Answer}
              formClassName='d-flex flex-column'
              info='Answer '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' Answer ',
                name: ' Answer',
                placeholder: 'Enter Answer',
              }}
              isInfo
              isMandatory
              label='Answer'
              sendValue={handleRichTextAnswer}
            />
          </div>
          <div className='col-sm-12 col-lg-12 mb-2'>
            <InputText
              changeHandler={(e) => handleChange('Tags', e.target.value)}
              formClassName='d-flex flex-column'
              info='Tags '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' Tags ',
                name: ' Tags',
                placeholder: 'Enter Tags',
                value: inputValues.Tags,
              }}
              isInfo
              label=' Tags'
              value={inputValues.Tags}
            />
          </div>
          <div className='col-sm-12 col-lg-12 mb-2'>
            <FileUpload
              fileError={fileError}
              filesProps={{ files, setFiles }}
              formClassName='d-flex flex-column'
              hint='Upload the files which are in the .png, .jpeg, .xlsx, .txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen'
              hintClassName='color-primary'
              info='Attach file (s) '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'Attachfiles ',
                name: ' Attach files ',
              }}
              isInfo
              label='Attach file (s) '
              note='Screenshots need to be saved locally before uploading into system.'
              noteClassName='color-primary'
              replaceFileProps={{replaceFile, setReplaceFile}}
              setFileError={setFileError}
            />
          </div>
          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={qAndAValidations.Status}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='Status'
              info='Status'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMandatory
              label='Status'
             
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Status'
              onChange={(e) => handleChange('Status', e.value)}
              options={Status}
              value={inputValues.Status}
            />
          </div>

          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={qAndAValidations.AssignedComponent}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='AssignedComponent'
              info='Assigned Component '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Assigned Component'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Assigned Component'
              onChange={changeAssignedComponent}
              options={assignedComponentOptions}
              value={inputValues.AssignedComponentCode}
            />
          </div>

          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              disabled={roleContext.isCPOwner || 
                roleContext.isAssignedComponentOwner}
              error={qAndAValidations.MAJCOM}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingMAJCOM'
              info='Servicing MAJCOM'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Servicing MAJCOM'
              
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Servicing MAJCOM'
              onChange={changeMajcom}
              options={majcomOptions}
              value={inputValues.ServicingMAJCOMCode}
            />
          </div>
          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              disabled={roleContext.isCPOwner || 
                roleContext.isAssignedComponentOwner || 
                roleContext.isMAJCOMOwner}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingOrganization'
              info='Servicing Organization'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Servicing Organization'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Servicing Organization'
              onChange={changeSquadron}
              options={squadronOptions}
              value={inputValues?.Squadron}
            />
          </div>
          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={qAndAValidations.Section}
              formClassName='form-vertical'
              id='Section'
              
              info='Section '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMulti
              label='Section'
              name='Section'
              onChange={changeSection}
              options={sectionOptions}
              value={inputValues.SectionCodeOptions}
            />
          </div>
          {inputValues.SectionCodes.length === 1 && <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='DashboardCategory'
              info='Category '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMulti
              label='Category'
              name='Category'
              onChange={changeCategory}
              options={categoryOptions}
              value={inputValues.CategoryCodeOptions}
            />
          </div>}

          {!showAddPopup && (
            <div className='col-sm-12 col-lg-4 mb-2'>
              <CustomSelect
                className='form-lg w-100 sourcesanspro font-13 customselect'
                formClassName='form-vertical text-nowrap poppins-semibold font-11'
                id='IsArchived'
                info='IsArchived'
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                }}
                isInfo
                label='Is Archived'
                menuPortalTarget={document.body}
                menuPosition={'fixed'}
                name='Is Archived'
                onChange={(e) => {
                  handleChange('IsArchived', e.value)
                }}
                options={IsArchived}
                value={inputValues.IsArchived}
              />
            </div>
          )}
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={() => {
                    handleSubmit()
                  }}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    filtersvalue(!showAddPopup)
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={() => {
                    handleSubmit()
                  }}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel?.()
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
